import CsAlert from '@/components/sideNavigation/Cs/alert/CsAlert';
import CsChatMessage from '@/components/sideNavigation/Cs/chatMessage/CsChatMessage';
import { BodyContent, HeaderLeft, HeaderRight, TAB_LIST } from '@/constants/cs';
import useGetCsMessage from '@/hooks/useGetCsMessageAlert';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';
import { CS_TAB } from '@/types/cs';
import styled, { css } from 'styled-components';

type Props = {
  isOpen: boolean;
};

function CsModal({ isOpen }: Props) {
  const dispatch = useAppDispatch();
  const { total1on1Count, totalProcessedCount } = useGetCsMessage();
  const { isOpenChat, isOpenAlert, activeTab } = useAppSelector(
    (state) => state.cs,
  );

  const onChangeTab = (tab: CS_TAB) => {
    dispatch(
      updateCs({
        activeTab: tab,
      }),
    );
  };

  if (isOpen) {
    return (
      <div>
        <Popover>
          <Header>
            <Title>{HeaderLeft(activeTab)}</Title>
            <HeaderRight currentTab={activeTab} />
          </Header>
          <SectionWrapper>{BodyContent(activeTab)}</SectionWrapper>
          <Footer>
            {TAB_LIST.map((tab) => (
              <NavButton
                key={tab.value}
                isActive={activeTab === tab.value}
                onClick={() => onChangeTab(tab.value)}
                hasAlert={
                  tab.value === 'CHAT'
                    ? total1on1Count > 0
                    : tab.value === 'RESULT'
                    ? totalProcessedCount > 0
                    : false
                }
              >
                {tab.icon(activeTab === tab.value ? '#3A3B3E' : '#80848A')}
                {tab.label}
              </NavButton>
            ))}
          </Footer>

          {isOpenChat && <CsChatMessage />}
          {isOpenAlert && <CsAlert />}
        </Popover>
      </div>
    );
  }

  return null;
}

const SectionWrapper = styled.div`
  width: 100%;
  height: calc(100% - 68px - 78px); // header, footer
  display: flex;
`;

const Footer = styled.footer`
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 78px;
  background-color: #f5f6f7;
  padding: 0 30px;
`;

const NavButton = styled.button<{ isActive: boolean; hasAlert?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 52px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  color: ${({ isActive }) => (isActive ? '#3a3b3e;' : '#80848A;')};
  white-space: nowrap;

  ${({ hasAlert = false }) =>
    hasAlert &&
    css`
      ::after {
        content: '';
        position: absolute;
        top: 0;
        right: 6px;
        width: 5px;
        height: 5px;
        background-color: #ff2d55;
        border-radius: 100px;
      }
    `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 20px 14px 20px;
  height: 68px;
`;

const Title = styled.strong`
  color: #3a3b3e;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const Popover = styled.aside`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  z-index: 450;
  width: 320px;
  height: 600px;
  border-radius: 20px;
  border: 0.3px solid #f5f6f7;
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(25, 46, 89, 0.3);
  overflow: hidden;
`;

export default CsModal;
